<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.25 10.4167L8.75 12.9167L13.75 7.08333"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle cx="10" cy="10" r="7.5" stroke="currentColor" stroke-width="1.5" />
  </svg>
</template>

<script setup lang="ts" />
